import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";

export function formatar_numeros_tabela_9(item: any) {
  return {
    ...item,
    quantidade: formatarNumero_recebido_com_casa_decimais(item.quantidade),
    consumo_energetico: formatarNumero_recebido_com_casa_decimais(item.consumo_energetico)
  };
}